import React, { FC, forwardRef } from 'react';
import Radio from '@material-ui/core/Radio';
import { MuiRadioProps } from './types';
import { makeStyles } from '@material-ui/core/styles';
import { theme } from '../styles/theme';
import { cx } from '../customEmotion';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: '50%',
    width: 20,
    height: 20,
    boxShadow: `inset 0 0 0 2px ${theme.color.text.B5}`,
    backgroundColor: 'transparent',
    '$root.Mui-focusVisible &': {
      boxShadow: `inset 0 0 0 2px ${theme.color.primary.default}`,
      backgroundColor: 'transparent',
    },
    'input:hover ~ &': {
      padding: 0,
      boxShadow: `inset 0 0 0 1px ${theme.color.primary.default}`,
    },
    'input:disabled ~ &': {
      boxShadow: `inset 0 0 0 2px ${theme.color.text.B3}`,
    backgroundColor: 'transparent',
    },
  },
  checkedIcon: {
    borderRadius: '50%',
    backgroundColor: 'transparent',
    boxShadow: `inset 0 0 0 6px ${theme.color.primary.default}`,
    'input:hover ~ &': {
      boxShadow: `inset 0 0 0 5px ${theme.color.primary.default}`,
      backgroundColor: 'transparent',
    },
  },
});

const MuiRadio: FC<MuiRadioProps> = forwardRef<HTMLButtonElement, MuiRadioProps>(
  ({ disabled, checked, value, classes, ...restProps }, ref) => {
    const css = useStyles();
    return (
      <Radio
        ref={ref}
        value={value}
        checked={checked}
        disabled={disabled}
        color='primary'
        icon={<span className={css.icon} />}
        checkedIcon={<span className={cx(css.icon, css.checkedIcon)} />}
        disableRipple
        disableFocusRipple
        {...restProps}
      ></Radio>
    );
  }
);

export default MuiRadio;
